import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class StepEstateLetterToFinancialInstitutionMeta extends BaseModel {
  hasExistingFinancialAccounts?: boolean;
  existingAccountsLocationKnown?: boolean;

  constructor(model: Partial<StepEstateLetterToFinancialInstitutionMeta> = {}) {
    super();

    this.hasExistingFinancialAccounts = model.hasExistingFinancialAccounts;
    this.existingAccountsLocationKnown = model.existingAccountsLocationKnown;
  }
}
